<template>
    <v-card class="elevation-0">
      <v-layout>
        <v-flex xs10>  
        <swiper class="note-slider center mx-auto" :options="sliderOptions" ref='mySwiper' id='mySwiper'>
        <swiper-slide v-for="(note, index) in notes" :key="note.midi">
          <button flat fab small :id="note.midi"  :ref="'b'+note.midi" class="note-button unselectable"
          @mousedown="startNote(note.pitch, index); "
          @touchstart="startNote(note.pitch, index)"
          @mouseup="stopNote"
					@mouseleave="stopNote"
          @touchend="stopNote"
					@blur="stopNote">
          {{note.name}}<span class="over-under" >
            <span class="over-under-row" v-html="note.sharp"></span>
            <span class="over-under-row">{{note.octave}}</span>
          </span>
          </button>    
        </swiper-slide>
        </swiper>
        <v-icon color="red" class="triangle-set center mx-auto ">navigation</v-icon>
        </v-flex>
        <v-flex xs2 class="mx-auto text-xs-left text-md-center"><v-btn color="green" fab dark mx-auto v-on:click="submitPitch()">Save</v-btn></v-flex> 
      </v-layout> 
    </v-card>    
</template>

<script>
import 'swiper/dist/css/swiper.css'
import GetActivityByUserQuery from './queries/GetActivityByUserQuery';
import DeleteActivityMutation from './mutations/DeleteActivityMutation';
import CreateActivityMutation from './mutations/CreateActivityMutation';


function deletePitch(that, pitchID, callback) {
  that.$apollo.mutate({ 
    variables: {
      input:{
        id: pitchID,  
      } 
    },
    mutation: DeleteActivityMutation})
    .then(function(data) {
      callback(data);
    }).catch(error => console.error(error));    
}

function getPitch(that, callback) {
  that.$apollo.query({ 
    variables: {
      actDate: localStorage.currentDate,
      username: localStorage.subID,         
    },
    query: GetActivityByUserQuery})
    .then(function(data) {
      callback(data);
    }).catch(error => {  console.log(error)});
}

function createPitch(that, item, callback) {
    
  //gather inputs
  var vpInput = {
    id: localStorage.subID+'--'+( new Date().getTime() ),
    username:  localStorage.subID,  
    actDate: localStorage.currentDate,
    activityType: 'VoiceCeilingPitch',
    timestamp: ( new Date().getTime() ),
    value: that.notes[that.$refs.mySwiper.swiper.activeIndex].midi,
    intensity: item,
  } 

  //add to dynamodb    
  that.$apollo.mutate({
    variables: {
      input: vpInput
    },
    mutation: CreateActivityMutation
  }).then(function(data) {
    console.log(data);
    callback(data);
  }).catch(error => console.error(error));
}


		// check for audio context



export default {
  data() {
    return {
      noteNames: ['C', 'C', 'D', 'D', 'E', 'F', 'F', 'G', 'G', 'A', 'A', 'B'],
      noteSharps: ['', '♯', '', '♯', '', '', '♯', '', '♯', '', '♯', ''],
      notes: [],
      sliderOptions: {
        spaceBetween: 1,
        centeredSlides: true,
        slidesPerView: 4,
        preventClicks: false,
        preventClicksPropagation: false,
        touchMoveStopPropagation: true,
        initialSlide: 24,
      },
      context: null,
      oscillator: null,
      gain: null,
      selectedPitch: null,
			tempSlideIndex: 24,
			actxt: null,
    }
  },
  mounted (that=this) {

		var AudioContext = window.AudioContext // Default
				|| window.webkitAudioContext // Safari and old versions of Chrome
				|| false; 

		if (AudioContext) {
				// Do whatever you want using the Web Audio API
				this.actxt = new AudioContext;
				this.context=this.actxt;
				// ...
		} else {
				// Web Audio API is not supported
				// Alert the user
				alert("Sorry, but the Web Audio API is not supported by your browser. Please, consider upgrading to the latest version or downloading Google Chrome or Mozilla Firefox");
		}

    if (!this.oscillator) {
      this.oscillator = this.context.createOscillator();
      this.oscillator.type = 'sine';
      this.oscillator.frequency.value = 440;
      this.oscillator.start();
      this.gain = this.context.createGain();
      this.gain.gain.value = 0;
      this.oscillator.connect(this.gain);
      this.gain.connect(this.context.destination);
    }
    this.gain.gain.value = 0
    
    var noteStart = 12*3 //C2
    var noteEnd = 12*8   //C7

    for (let note = noteStart; note <= noteEnd; note++) {
      this.notes.push({
        name: this.noteNames[note%12],
        sharp: this.noteSharps[note%12],
        octave: Math.floor(note/12)-1,
        midi: note,
        //midi update adjustment correction
        pitch: 8.17575*Math.pow(2, note/12)
      });
    }

    getPitch(that, function(data){ 
      var elems = document.querySelectorAll(".note-button");
      [].forEach.call(elems, function(el) {
        el.className = el.className.replace(/\btodaySelected\b/, "");
      });
        
      data.data.getActivityByUser.items.forEach( element => {
        if(element.activityType=="VoiceCeilingPitch"){ 
          document.getElementById(""+element.value).className += " todaySelected";
          var pos=that.notes.map(it => it.midi ).indexOf(element.value);
          that.$refs.mySwiper.swiper.slideTo(pos); 
        }
      });   
    }); 

    this.$root.$on('DateChange', () => {
      var that=this;
      if(that.$router.currentRoute.path=="/home"){
        getPitch(that, function(data){ 
          var elems = document.querySelectorAll(".note-button");
          [].forEach.call(elems, function(el) {
            el.className = el.className.replace(/\btodaySelected\b/, "");
          });
      
          data.data.getActivityByUser.items.forEach(element => {
            if(element.activityType=="VoiceCeilingPitch"){ 
              document.getElementById(""+element.value).className += " todaySelected";
              if(that.$refs.mySwiper.swiper){
                
                var pos=that.notes.map(it => it.midi).indexOf(element.value);
                that.$refs.mySwiper.swiper.slideTo(pos); 
              } 
            }
          }); 
        
        }); 
      }
    }); 

  },
  beforeDestroy(){
		var that=this;
		that.actxt.close();
    that.$root.$off('DateChange');
  },
  methods: {
    startNote(pitch, id) {
      this.context.resume().then(() => {
        this.selectedPitch=this.notes[id].name+''+this.notes[id].sharp+''+this.notes[id].octave;
        const now = this.context.currentTime;
        // going to 0 then coming back prevents clicking sounds when switching pitches
        const gainTaperTime = this.gain.gain.value / (this.gain.gain.value + 0.5) * 0.2;
        this.gain.gain.cancelScheduledValues(now);
        // after 4 of time constants have passed, (value-target)/(target0-value0) ~= .018
        // that's close enough to 0 to hide the click
        this.gain.gain.setTargetAtTime(0, now, gainTaperTime/4);
        this.oscillator.frequency.setValueAtTime(pitch, now+gainTaperTime);
        this.gain.gain.setTargetAtTime(0.5, now+gainTaperTime, (0.2-gainTaperTime)/4);
      });
    },
    stopNote() {
      const now = this.context.currentTime;
      this.gain.gain.cancelScheduledValues(now);
      this.gain.gain.setTargetAtTime(0, now, 0.15);
    },
    submitPitch(){
      var elems = document.querySelectorAll(".note-button");
      [].forEach.call(elems, function(el) {
        el.className = el.className.replace(/\btodaySelected\b/, "");
      });
      //this gives us our pitch value
      var that=this;
      var actid=this.$refs.mySwiper.swiper.activeIndex;
      this.selectedPitch=this.notes[actid].name+''+this.notes[actid].sharp+''+this.notes[actid].octave;
      this.deleteAllPitch(that, function(){
        createPitch(that, that.selectedPitch, function(){
            
          document.getElementById(""+that.notes[that.$refs.mySwiper.swiper.activeIndex].midi).className += " todaySelected";
          
        });
      });
    },
    deleteAllPitch: function(that, callback){

      getPitch(that, function(data){ 
        data.data.getActivityByUser.items.forEach(element => {
          if(element.activityType=="VoiceCeilingPitch"){
            deletePitch(that, element.id, function(){});
          }
        });
        callback(true);
      });
    }, 
  }
}
</script>
<style scoped>
.note-slider{
  border: 4px solid #e0e0e0;
  border-radius:11px;
  height: 71px;
  min-height: 71px;
  padding: 14px;
}
.note-slider button{
  height: 100%;
  vertical-align: middle;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.75rem;
  font-weight: bold;
}

.note-button span.over-under {
  position: relative;
  top: 0.1em;
  font-size: 70%;
  display: inline-block;
}
button.note-button { width: 100%;}
.note-button .btn__content span.over-under > .over-under-row {
  position: unset;
  transform: unset;
  opacity: unset;
  display: table-row;
}
.triangle-set{
  bottom: 12px;
  z-index: 100;
  width: 100%;
  text-align: center;
  margin-top: -40px;
}
.swiper-slide {
  width: 30px;
  text-align: center;
}
.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
button.note-button.unselectable:focus-within {
  outline: none;
}
button.note-button.unselectable:hover{
  background: #eee;
  border-radius: 24px;
}
button.todaySelected {
  outline: none;
  background: #4caf4f47 !important;
  border-radius: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/Slider.vue